import { FC } from 'react';
import styled from 'styled-components';
import { getMilesText } from '../../../../../services/utils/FormatHelper';
import { theme } from '../../../../../styles/theme';
import { Icon, Typography } from '../../../../style';
import { ContractDataProps } from '../contract-modal/ContractDetails';
import { StyledColumn, StyledRow } from './Style';

const WarrantyDetails: FC<ContractDataProps> = (props) => {
  const hasExtendedWarranty = props.data.hasExtendedWarranty;

  return (
    <Wrapper data-testid='warranty-details-table'>
      <tbody>
        <StyledRow>
          <StyledColumn columnSize='col-sm-3'>
            <Typography
              size={theme.typography.h5}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.wetAsphalt}
            >
              Warranty Exp. Miles
            </Typography>
          </StyledColumn>
          <StyledColumn columnSize='col-sm-3'>
            <Typography
              size={theme.typography.h5}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.wetAsphalt}
            >
              Warranty Exp. Date
            </Typography>
          </StyledColumn>
        </StyledRow>
        <StyledRow>
          <StyledColumn columnSize='col-sm-3'>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.normal}
              color={theme.palette.grey}
            >
              {props.data.warrantyMiles ? getMilesText(props.data.warrantyMiles) : 'N/A'}
            </Typography>
          </StyledColumn>

          <StyledColumn columnSize='col-sm-3'>
            <Icon
              className='warranty-details warranty-expire-date-icon'
              type='calendar'
              data-testid='warranty-expire-date-icon'
              size={15}
              color={theme.palette.dusty}
            >
              &nbsp;
            </Icon>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.normal}
              color={theme.palette.grey}
            >
              {props.data.warrantyDate ? props.data.warrantyDate : 'N/A'}
            </Typography>
          </StyledColumn>
          <StyledColumn columnSize='col-sm-6'>
            {hasExtendedWarranty ? (
              <div className='d-flex'>
                <Icon
                  className='warranty-details have-extended-warranty-icon me-2'
                  type='checkmark'
                  data-testid='have-extended-warranty-icon'
                  size={18}
                  color={theme.palette.success}
                ></Icon>
                <Typography
                  size={theme.typography.h5}
                  fontWeight={theme.typography.fontWeights.normal}
                  color={theme.palette.wetAsphalt}
                >
                  Has an extended warranty (Expiration unknown)
                </Typography>
              </div>
            ) : (
              <div>
                <Icon
                  className='warranty-details not-have-extended-warranty-icon me-2'
                  type='stop'
                  data-testid='not-have-extended-warranty-icon'
                  size={15}
                  color={theme.palette.basicGray}
                ></Icon>
                <Typography
                  size={theme.typography.h5}
                  fontWeight={theme.typography.fontWeights.normal}
                  color={theme.palette.wetAsphalt}
                >
                  Does not have an extended warranty
                </Typography>
              </div>
            )}
          </StyledColumn>
        </StyledRow>
      </tbody>
    </Wrapper>
  );
};

export default WarrantyDetails;

const Wrapper = styled.table`
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  & tr {
    padding-top: 15px;
    line-height: 26px;
  }
  & tr:last-child {
    padding-top: 5px;
  }
  .me-2 {
    margin-right: 7px;
  }
`;
